"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isContained = exports.USES = void 0;
var USES = ['default', 'enclosed', 'flush', 'header', 'toolbar'];
exports.USES = USES;

var isContained = function isContained(use) {
  return use === 'enclosed' || use === 'flush' || use === 'toolbar';
};

exports.isContained = isContained;